import React, { Component, Fragment } from "react";
import Label from "../../../../components/atoms/Label";
import LabelWithText from "../../../../components/molecules/LabelWithText";
import Button from "../../../../components/atoms/Button";
import DataPinjaman from "./DataPinjaman";
import InformasiDokumen from "./InformasiDokumen";
import DataJaminan from "./DataJaminan";
import RiwayatNegosiasi from "./RiwayatNegosiasi";

export default ({ statusBtn, changeBtn, onChangeDataNegosiasi, dataNegosiasi, dataDetail, nextNego, accNego, rjtLoan, ajukanNego, resetValNego, statusNextNego, LoanGrade, generateDoc, profile }) => {
	let col = { label: "col-md-3", text: "col-md-9" };
	const sortDate = (date) => {
		if (date) {
			let sortDate = date.sort(function (a, b) {
				return new Date(b.createdAt) - new Date(a.createdAt);
			});
			//console.log({ date, sortDate });

			return date;
		}
	};
	//console.log(sortDate(dataDetail.offeringHistory));
	return (
		<div>
			<div className="bg-vertical-scroll bg-button-vertical">
				{statusBtn.map((value, index) => {
					return (
						<Fragment key={index}>
							{value.status ? (
								<Button title={value.title} type={"button"} color="yellow" width="small-rounded" onClick={() => changeBtn(index)} />
							) : (
								<Button title={value.title} type={"button"} color="yellow" width="small-rounded outline" onClick={() => changeBtn(index)} />
							)}
						</Fragment>
					);
				})}
			</div>
			<div className="card-data-pinjaman">
				{statusBtn.map((value, index) => {
					if (value.status) {
						if (value.key === "DataPinjaman") {
							// dataDetail.offeringHistory && console.log("apami == ", sortDate(dataDetail.offeringHistory)[0].userType);

							if (dataDetail.loanStatus === "AP0" && dataDetail.offeringHistory) {
								if (sortDate(dataDetail.offeringHistory)[0].userType === "BRW") {
									return <DataPinjaman key={index} title={value.title} dataDetail={dataDetail} LoanGrade={LoanGrade} />;
								} else {
									if (statusNextNego) {
										return (
											<DataPinjaman
												key={index}
												title={value.title}
												btnBottom={
													dataNegosiasi.statusCompare
														? [{ name: "AJUKAN", color: "blue", onClick: ajukanNego }]
														: [
																{ name: "AJUKAN", color: "blue", onClick: ajukanNego },
																{ name: "KEMBALI", outline: true, onClick: resetValNego },
														  ]
												}
												onChangeDataNegosiasi={onChangeDataNegosiasi}
												dataNegosiasi={dataNegosiasi}
												dataDetail={dataDetail}
												nextNego={nextNego}
												statusNextNego={statusNextNego}
												LoanGrade={LoanGrade}
											/>
										);
									} else {
										return (
											<DataPinjaman
												key={index}
												title={value.title}
												dataDetail={dataDetail}
												btnBottom={[
													{ name: "SETUJUI", color: "blue", onClick: accNego },
													{ name: "TOLAK", color: "red", onClick: rjtLoan },
												]}
												nextNego={nextNego}
												LoanGrade={LoanGrade}
											/>
										);
									}
								}
							} else if (dataDetail.loanStatus === "AGR") {
								return (
									<Fragment key={index}>
										<DataPinjaman
											title={value.title}
											dataDetail={dataDetail}
											btnBottom={[
												{
													name: "TANDA TANGAN",
													color: "blue",
													onClick: generateDoc,
													isDisabled: dataDetail.digisignCheck && profile && dataDetail.digisignCheck.signRecipient[0].userUID === profile.picDetail.picUID && dataDetail.digisignCheck.signRecipient[0].isSigned,
												},
												{ name: "BATAL", color: "red", onClick: rjtLoan, isDisabled: false },
											]}
											LoanGrade={LoanGrade}
										/>
									</Fragment>
								);
							} else {
								return <DataPinjaman key={index} title={value.title} dataDetail={dataDetail} LoanGrade={LoanGrade} />;
							}
						} else if (value.key === "InformasiDokumen") {
							return <InformasiDokumen key={index} title={value.title} infoDocs={dataDetail.infoDocs} agreementDocs={dataDetail.loanAgreement} />;
						} else if (value.key === "DataJaminan") {
							return <DataJaminan key={index} title={value.title} infoCollateral={dataDetail.infoCollateral} />;
						} else if (value.key === "RiwayatNegosiasi") {
							return <RiwayatNegosiasi key={index} title={value.title} offeringHistory={sortDate(dataDetail.offeringHistory)} />;
						}
					}
				})}
			</div>
		</div>
	);
};
